<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          Outsourcing StockIn No：{{
            formData.mrpOutsourcingStockInNo
              ? formData.mrpOutsourcingStockInNo
              : 'New'
          }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <b-badge
          style="font-size: 12px"
          :variant="
            formData.outsourcingStockInStatus === 'Y'
              ? 'success'
              : formData.outsourcingStockInStatus === 'D'
              ? 'warning'
              : 'primary'
          "
        >
          {{ formData.v_outsourcingStockInStatus || 'New' }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Update：{{ formData.modifyByName ? formData.modifyByName : '--' }} at
          {{ formData.modifyDate ? formData.modifyDate : '--' }}
        </span>
      </div>
    </div>
    <el-form
      ref="form"
      label-position="top"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.form_label_buyer') || '采购人员'"
            prop="buyerCode"
          >
            <dict-select
              v-model="formData.buyerCode"
              :selectedLabel.sync="formData.buyerName"
              url="/master/common/dict/baseUserSelect"
              size="mini"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.form_label_warehouse_name') || '入库仓库'"
            prop="warehouseCode"
          >
            <dict-select
              clearable
              v-model="formData.warehouseCode"
              :selectedLabel.sync="formData.warehouseName"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              filterable
              size="mini"
              url="/ecom/warehouse/cn/warehouse/select"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.form_label_stockInDate') || '入库日期'"
            prop="stockInDate"
          >
            <el-date-picker
              v-model="formData.stockInDate"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            :label="
              $l('INDEX.table_label_production_order_scm_name') || '供应商名称'
            "
            prop="scmCode"
          >
            <dict-select
              size="mini"
              clearable
              filterable
              v-model="formData.scmCode"
              :selectedLabel.sync="formData.scmName"
              url="/master/common/dict/scmPartners"
              @change="clearBatch"
            ></dict-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.table_label_order_no') || '订单编号'"
            prop="orderNo"
          >
            <el-input
              v-model="formData.orderNo"
              clearable
              maxlength="50"
              @change="clearBatch"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item :label="$l('INDEX.table_label_contactMemo') || '备注'">
            <el-input
              v-model="formData.remark"
              type="textarea"
              clearable
              size="small"
              rows="2"
              maxlength="1000"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <OutsourcingStockInTable
          ref="outsourcingStockInTable"
          :disabled="disabled"
          :tableData="formData.mrpOutsourcingStockInDetailList"
          :scmCode="formData.scmCode"
          :orderNo="formData.orderNo"
        />
      </el-row>
    </el-form>
    <div class="d-flex justify-content-end mt-2 mb-2" v-if="!disabled">
      <span slot="footer">
        <el-button size="small" @click="cancel()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" v-if="!disabled" @click="save()">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </div>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import OutsourcingStockInTable from '../outsourcing-stock-in-table'
export default {
  mixins: [EditLoading],
  components: {
    OutsourcingStockInTable,
  },
  props: {
    mrpOutsourcingStockInCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      backDialogVisible: false,
      formData: { buyerCode: '', buyerName: '' },
      rules: {
        // buyerCode: [
        //   {
        //     required: true,
        //     message:
        //       this.$l('INDEX.form_placeholder_buyer') || '请选择采购人员',
        //     trigger: 'change',
        //   },
        // ],
        scmCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_scmCode') || '请选择供应商',
            trigger: 'blur',
          },
        ],
        orderNo: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_order_no') || '请输入订单编号',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {
    ...mapState('admin/user', ['info']),
  },
  watch: {
    info: {
      handler(userInfo) {
        if (!userInfo || userInfo === {}) return
        const { userCode, userName, userNameEn } = userInfo
        this.formData.buyerCode = userCode || ''
        this.formData.buyerName = [userNameEn, userName]
          .filter(Boolean)
          .join('-')
      },
      immediate: true,
    },
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      if (!this.mrpOutsourcingStockInCode) return
      this.$api
        .mrpOutsourcingStockInDetailApi({
          mrpOutsourcingStockInCode: this.mrpOutsourcingStockInCode,
        })
        .then((res) => {
          const { body } = res
          this.formData = {
            ...body,
          }
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      const materialBatchResult = await this.$refs.outsourcingStockInTable.validate()
      if (!result || !materialBatchResult)
        return (this.backDialogVisible = false)

      this.formData.mrpOutsourcingStockInDetailList = this.$refs.outsourcingStockInTable.getTableData()
      this.loadingOpen()
      this.$api
        .mrpOutsourcingStockInSaveApi(this.formData)
        .then(() => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功',
            type: 'success',
          })
          this.$emit('reload')
          this.$emit('close')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    clearBatch() {
      this.formData.mrpOutsourcingStockInDetailList = []
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
</style>
